import { Box, Grid, Modal } from '@mui/material';
import { IoCloseCircleOutline } from 'react-icons/io5';
import Button from '@mui/material/Button';
import ConnectButton from '../../WagmiProvider/ConnectButton';
import React, { useEffect, useMemo, useState } from 'react';
import OTPInput from 'otp-input-react';
import useScreenSize from '../../hooks/useScreenSize';
import { useAccount } from 'wagmi';

type ReferralCodeModalProps = {
  redeemReferralCode: (code: string) => Promise<boolean>;
  referralCode?: string;
  isModalOpen?: boolean;
  setIsRedeemModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ReferralCodeModal = ({
  redeemReferralCode,
  referralCode: referralCodeProp = '',
  isModalOpen = false,
  setIsRedeemModalOpen,
}: ReferralCodeModalProps) => {
  const { isConnected } = useAccount();
  const [referralCode, setReferralCode] = useState(referralCodeProp);

  const { screenSize } = useScreenSize();

  const OtpInputStyles = useMemo(
    () => ({
      textAlign: 'center',
      border: '1px solid #FFFFFF17',
      outline: 'none',
      backgroundColor: '#FFFFFF17',
      borderRadius: '8px',
      color: '#ffffff',
      fontSize: '28px',
      fontFamily: 'Poppins',
      marginRight: 0,
      ...(screenSize[0] < 500
        ? { width: '60px', height: '60px' }
        : { width: '80px', height: '60px' }),
    }),
    [screenSize],
  );

  return (
    <Modal
      open={isModalOpen}
      // onClose={() => { setInviteModal(false); }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      // sx={{backgroundColor:"#FFFFFF1A"}}
      slotProps={{
        backdrop: { style: { backgroundColor: 'rgba(0, 0, 0, 0.6)' } },
      }}
    >
      <Box
        className="bg-modalBg max-w-full max-h-full p-3 md:!p-16 flex rounded-xl absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
        sx={{
          width: '1000px',
        }}
      >
        <Grid
          container
          lg={12}
          display={'flex'}
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'center'}
          className="max-h-full flex"
        >
          <Box className="absolute top-3 right-3">
            <IoCloseCircleOutline
              onClick={() => setIsRedeemModalOpen(false)}
              style={{ cursor: 'pointer', color: '#FFF' }}
              size={25}
            />
          </Box>
          <Grid
            item
            xs={12}
            display={'flex'}
            flexDirection={{
              lg: 'row',
              md: 'column',
              sm: 'column',
              xs: 'column',
            }}
            alignItems={'stretch'}
            justifyContent="center"
            className="max-h-full"
          >
            <Grid
              item
              lg="auto"
              xs={12}
              display={'flex'}
              flexDirection={'column'}
              alignItems="center"
              justifyContent={'center'}
            >
              <Grid
                item
                className=""
                lg={12}
                md={12}
                sm={12}
                xs={12}
                display={'flex'}
                flexDirection={'column'}
                alignItems={'center'}
                justifyContent={'center'}
                textAlign="center"
                style={{ marginTop: '5%' }}
              >
                <p className="airdrop_landingHeading">OpenZK Airdrop</p>
                <p className="airdrop_paratext mt-4">
                  Enter your Referral Code to claim your Airdrop Points
                </p>
              </Grid>

              <Grid
                item
                className="mt-3"
                lg={12}
                md={12}
                display={'flex'}
                flexDirection={'column'}
                alignItems="center"
                justifyContent={'flex-start'}
              >
                <OTPInput
                  value={referralCode}
                  className="gap-4"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    marginLeft: '0%',
                  }}
                  inputStyles={OtpInputStyles}
                  onChange={setReferralCode}
                  OTPLength={5}
                  disabled={false}
                  autoFocus
                />
              </Grid>

              <Grid
                item
                className="mt-5 mb-4 w-100"
                lg={12}
                md={12}
                sm={12}
                xs={12}
                display={'flex'}
                flexDirection={'row'}
                alignItems={'center'}
                justifyContent={'center'}
              >
                {isConnected ? (
                  <Button
                    className="mr-2"
                    sx={{
                      height: '40px',
                      width: 'auto',
                      backgroundColor: '#000000',
                      border: 0.75,
                      borderColor: '#FC9D4B',
                      borderRadius: '10px',
                      color: '#FFE584',
                      fontWeight: 'semibold',
                      fontFamily: 'PoppinsRegular',
                      boxShadow: '0px 0px 13px 1px #FC9D4B',
                      fontSize: {
                        xs: '10px', // For extra small screens (mobile)
                        sm: '16px', // For small screens (tablets)
                        md: '18px', // For medium screens
                        lg: '18px', // For large screens
                      },
                      padding: {
                        xs: '15px', // For extra small screens
                        sm: '12px', // For small screens
                        md: '15px', // For medium screens
                      },
                      '&:hover': {
                        background:
                          'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
                        color: '#ffffff',
                      },
                      textTransform: 'none',
                    }}
                    onClick={() => {
                      if (referralCode.trim().length == 5) {
                        redeemReferralCode(referralCode).then((success) => {
                          if (success) {
                            () => setIsRedeemModalOpen(false);
                          }
                        });
                      }
                    }}
                  >
                    {referralCode.trim().length == 5
                      ? 'Redeem Invite Code'
                      : 'Enter Invite Code'}
                  </Button>
                ) : (
                  <ConnectButton />
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};
